<template>
  <Teleport to="body">
    <div
      v-if="visible"
      class="mosta-context-menu-backdrop"
      :style="backdropStyle"
      @click="emit('close')"
    >
      <div
        :class="['mosta-context-menu', menuClass]"
        :style="menuStyle"
        @click.stop
        @mouseenter="emit('menuEnter')"
        @mouseleave="emit('menuLeave')"
      >
        <slot />
      </div>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const props = withDefaults(defineProps<{
  visible: boolean;
  position: { top: string; left: string };
  minWidth?: number;
  menuClass?: string;
  backdropCursor?: string;
  disableBackdropPointer?: boolean;
}>(), {
  minWidth: 200,
  menuClass: '',
  backdropCursor: 'default',
  disableBackdropPointer: false,
});

const emit = defineEmits<{
  (e: 'close'): void;
  (e: 'menuEnter'): void;
  (e: 'menuLeave'): void;
}>();

const menuStyle = computed(() => ({
  top: props.position?.top ?? '0px',
  left: props.position?.left ?? '0px',
  minWidth: `${props.minWidth}px`,
}));

const backdropStyle = computed(() => ({
  cursor: props.backdropCursor,
  pointerEvents: props.disableBackdropPointer ? 'none' : 'auto',
}));
</script>

<style lang="scss">
.mosta-context-menu-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
}

.mosta-context-menu {
  position: fixed;
  z-index: 10000;
  pointer-events: auto;
}
</style>
